import { useState, useEffect } from 'react';
import axios from 'axios';
import { ClipboardList, Trash2, Check, X as XIcon, Clock } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PedidosPage() {
  const [pedidos, setPedidos] = useState([]);
  const [loading, setLoading] = useState(true);

  const carregar = () => {
    axios.get(`${API}/pedidos-visita`).then(r => setPedidos(r.data)).catch(console.error).finally(() => setLoading(false));
  };
  useEffect(() => { carregar(); }, []);

  const alterarEstado = async (id, estado) => {
    await axios.patch(`${API}/pedidos-visita/${id}`, { estado });
    carregar();
  };

  const eliminar = async (id) => {
    if (!window.confirm('Eliminar este pedido?')) return;
    await axios.delete(`${API}/pedidos-visita/${id}`);
    carregar();
  };

  const estadoBadge = (e) => {
    const map = {
      pendente: 'bg-yellow-100 text-yellow-800',
      aprovado: 'bg-green-100 text-green-800',
      cancelado: 'bg-red-100 text-red-800'
    };
    return map[e] || 'bg-muted text-muted-foreground';
  };

  if (loading) return <div className="text-center py-12 text-muted-foreground">A carregar...</div>;

  return (
    <div data-testid="pedidos-page">
      <h2 className="font-heading font-bold text-2xl mb-6 flex items-center gap-2">
        <ClipboardList className="w-6 h-6 text-primary" /> Pedidos de Visita
      </h2>
      {pedidos.length === 0 ? (
        <p className="text-muted-foreground text-center py-12">Nenhum pedido de visita.</p>
      ) : (
        <div className="bg-card rounded-2xl border border-border overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead className="bg-muted/50 border-b border-border">
                <tr>
                  <th className="text-left p-3 font-medium">Animal</th>
                  <th className="text-left p-3 font-medium">Nome</th>
                  <th className="text-left p-3 font-medium">Email</th>
                  <th className="text-left p-3 font-medium">Telefone</th>
                  <th className="text-left p-3 font-medium">Data Visita</th>
                  <th className="text-left p-3 font-medium">Estado</th>
                  <th className="text-left p-3 font-medium">Acoes</th>
                </tr>
              </thead>
              <tbody>
                {pedidos.map(p => (
                  <tr key={p.id} className="border-b border-border hover:bg-muted/30 transition-colors">
                    <td className="p-3">{p.nome_animal || p.animal_id || '-'}</td>
                    <td className="p-3 font-medium">{p.nome}</td>
                    <td className="p-3">{p.email}</td>
                    <td className="p-3">{p.telefone || p.telemovel || '-'}</td>
                    <td className="p-3">{p.data_preferida || p.data_visita || '-'}</td>
                    <td className="p-3">
                      <select value={p.estado} onChange={e => alterarEstado(p.id, e.target.value)}
                        className={`text-xs px-2 py-1 rounded-full border-0 font-medium ${estadoBadge(p.estado)}`}>
                        <option value="pendente">Pendente</option>
                        <option value="aprovado">Aprovado</option>
                        <option value="cancelado">Cancelado</option>
                      </select>
                    </td>
                    <td className="p-3">
                      <button onClick={() => eliminar(p.id)} className="text-destructive hover:bg-destructive/10 p-1.5 rounded-full transition-colors">
                        <Trash2 className="w-4 h-4" />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}
